module.exports = __webpack_public_path__ + "img/users-check.7b697c1c.svg";